// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-57a1add2] .el-dialog__header{background-color:#d7d7d7}[data-v-57a1add2] .el-dialog__header .el-dialog__title{font-weight:700}[data-v-57a1add2] .el-form-item__error{position:relative}[data-v-57a1add2] .el-dialog__footer .button{display:flex;justify-content:center}.el-row[data-v-57a1add2]{padding:10px 0;border-bottom:1px dashed #aaa}[data-v-57a1add2] .el-form{margin-top:-8px}[data-v-57a1add2] .el-form .el-form-item{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
